import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { countResponseSchema } from '../types';

export const createDeleteAccountMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'DELETE',
			url: (id) => `/account/${id}`,
			body: {},
		},
		response: {
			contract: zodContract(countResponseSchema),
		},
	});
